import Cookies from 'js-cookie';

document.addEventListener('click', function(event) {
  var gridStyleButton = event.target.closest('.grid-style-js');
  if (!gridStyleButton) return;

  var activeMode = gridStyleButton.name;
  var productsContainer = document.getElementById('products-js');
  if (productsContainer) {
    productsContainer.classList.remove('products-list', 'products-grid');
    productsContainer.classList.add('products-' + activeMode);
  }

  document.querySelectorAll('.grid-style-js').forEach(function(button) {
    if (button.name === activeMode) {
      button.classList.remove('btn-outline-primary');
      button.classList.add('btn-primary');
    } else {
      button.classList.add('btn-outline-primary');
      button.classList.remove('btn-primary');
    }
  });

  Cookies.set('grid_style', activeMode, { expires: 365 });
});

document.addEventListener('click', function(event) {
  var showAllButton = event.target.closest('.show-all-alts-js');
  if (!showAllButton) return;

  var showAllContainer = showAllButton.closest('.show-all-alts-container-js');
  if (!showAllContainer) return;

  showAllContainer.parentElement.querySelectorAll('.alt-card-js').forEach(function(altCard) {
    altCard.classList.remove('d-none');
  });
  showAllContainer.classList.add('d-none');
});
